/* eslint-disable */

import Flickity from 'flickity'

export default mobileImageNav => {
  const slideshow = $(mobileImageNav)
  const leftArrow = $('.js-carousel-left')
  const rightArrow = $('.js-carousel-right')
  if (slideshow) {
    const flkty = new Flickity(mobileImageNav, {
      contain: true,
      prevNextButtons: false,
      wrapAround: true,
      autoPlay: false
    })

    flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })

    setTimeout(() => {
      flkty.resize()
    }, 1500)

    $(leftArrow).click(() => flkty.previous())
    $(rightArrow).click(() => flkty.next())
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/mobile-slider.js